<template>
  <div>
    <!--
      Duas formas de aparecer, mesmo conteúdo. Na tela Campos de Integração, o
      editor é um modal aberto a partir de uma lista de dezenas de tipos. Na tela
      de uma integração, ele É a seção de mapeamento: abrir um modal por cima de
      uma tela que já está falando daquele conector esconde o que está em volta
      sem nada em troca.
    -->
    <component
      :is="embutido ? 'div' : 'modal'"
      :class="embutido ? 'editor-embutido' : null"
      v-bind="embutido ? {} : propriedadesDoModal"
      @before-open="onBeforeOpen"
    >
      <CamposDisponiveis
          :campos="tipo.de"
          :aberto="listaAberta === 'de'"
          :ancora="ancoraDaLista"
          :onSelect="alterarCampoDe"
          @fechar="fecharLista"
      />
      <CamposDisponiveis
          :campos="tipo.para"
          :aberto="listaAberta === 'para'"
          :ancora="ancoraDaLista"
          :onSelect="alterarCampoPara"
          @fechar="fecharLista"
      />
      <CloseModal v-if="!embutido" :close="tentarFechar"/>

      <div class="modalbox">
        <div class="modalbox-content">
          <!--
            Embutido, a seção que hospeda o editor já diz de qual conector e de
            qual tipo se trata. O caminho só volta a informar quando se entra
            numa vista de onde é preciso voltar.
          -->
          <nav
            v-if="!embutido || vista !== vistaDeLista"
            class="breadcrumb-bar"
            aria-label="Localização atual"
          >
            <span class="breadcrumb-item">
              <fa-icon icon="exchange-alt" /> {{ tipo.titulo }}
            </span>
            <fa-icon icon="chevron-right" class="breadcrumb-sep" />
            <span class="breadcrumb-item" :class="{ 'breadcrumb-item--ativo': vistaEhLista }">
              <a v-if="vista !== vistaDeLista" href="#" @click.prevent="voltarLista">Mapeamentos</a>
              <span v-else>Mapeamentos</span>
            </span>
            <template v-if="vista !== 'lista'">
              <fa-icon icon="chevron-right" class="breadcrumb-sep" />
              <span class="breadcrumb-item breadcrumb-item--ativo">
                {{ vista === 'tipo' ? 'Tipo de mapeamento' : (campoEditandoRef && campoEditandoRef.regra ? badgeLabel(campoEditandoRef) : 'Campo simples') }}
              </span>
            </template>
          </nav>

          <div class="modal-header-info" v-if="vista === 'lista' && !embutido">
            <div class="header-title">{{ tipo.titulo }}</div>
            <div class="header-desc">
              Chave: <code>{{ tipo.chave }}</code> · {{ campos.length }} mapeamento(s)
            </div>
          </div>

          <!--
            VISTA: SIMPLES — duas colunas e uma seta.

            É a forma como um de/para se lê: o campo que vem de lá, o campo que
            recebe aqui. Tudo o mais que este editor sabe fazer (regra
            condicional, funções, formato, valor padrão) continua existindo,
            atrás de "Opções avançadas" — mas deixou de ser o que aparece
            primeiro, porque a esmagadora maioria dos vínculos é campo a campo.
          -->
          <template v-if="vista === 'simples'">
            <div v-if="campos.length === 0" class="simples-vazio">
              <fa-icon icon="exchange-alt" class="simples-vazio-icone" />
              <div class="simples-vazio-texto">Nenhum campo vinculado</div>
              <div class="simples-vazio-desc">
                Escolha de qual campo do serviço sai cada dado do cadastro.
              </div>
            </div>

            <div v-else class="simples-tabela">
              <div class="simples-cabecalho">
                <span>{{ vocabulario.origem }}</span>
                <span></span>
                <span>{{ vocabulario.destino }}</span>
                <span></span>
              </div>

              <div
                v-for="(campo, idx) in campos"
                :key="idx"
                class="simples-linha"
                :class="{ 'simples-linha--invalida': !isCampoValido(campo) }"
              >
                <!--
                  Linha com regra não cabe em dois selects: o que ela faz é uma
                  decisão, não uma origem. Mostra o que é e abre no avançado.
                -->
                <template v-if="campo.regra">
                  <div class="simples-regra">
                    <span class="lista-tipo-badge" :class="badgeClass(campo)">
                      <fa-icon :icon="badgeIcone(campo)" /> {{ badgeLabel(campo) }}
                    </span>
                    <span class="simples-regra-resumo">{{ campo.nome || resumoLinha(campo) }}</span>
                  </div>
                </template>

                <template v-else>
                  <v-select
                    class="simples-campo"
                    :options="opcoesDe"
                    label="rotulo"
                    :value="opcaoDoCampo(tipo.de, campo.de)"
                    :filter-by="filtrarOpcao"
                    placeholder="Campo do serviço"
                    @input="definirDe(idx, $event)"
                  >
                    <template #option="opcao">
                      <div class="opcao-campo">
                        <span class="opcao-rotulo">{{ opcao.rotulo }}</span>
                        <code class="opcao-id">{{ opcao.valor }}</code>
                      </div>
                    </template>
                  </v-select>

                  <fa-icon icon="arrow-right" class="simples-seta" />

                  <v-select
                    class="simples-campo"
                    :options="opcoesPara"
                    label="rotulo"
                    :value="opcaoDoCampo(tipo.para, campo.para)"
                    :filter-by="filtrarOpcao"
                    placeholder="Campo do cadastro"
                    @input="definirPara(idx, $event)"
                  >
                    <template #option="opcao">
                      <div class="opcao-campo">
                        <span class="opcao-rotulo">{{ opcao.rotulo }}</span>
                        <code class="opcao-id">{{ opcao.valor }}</code>
                      </div>
                    </template>
                  </v-select>
                </template>

                <div class="simples-acoes">
                  <CButton
                    color="link"
                    size="sm"
                    class="btn-icon"
                    title="Mais opções deste vínculo"
                    aria-label="Mais opções deste vínculo"
                    @click="abrirEditor(idx)"
                  >
                    <fa-icon icon="sliders-h" />
                  </CButton>
                  <CButton
                    color="danger"
                    variant="ghost"
                    size="sm"
                    class="btn-icon"
                    title="Remover"
                    aria-label="Remover vínculo"
                    @click="onRemoveCampo(idx)"
                  >
                    <fa-icon icon="trash-alt" />
                  </CButton>
                </div>
              </div>
            </div>

            <div class="simples-rodape">
              <CButton color="primary" variant="outline" size="sm" class="btn-dashed" @click="adicionarVinculo">
                <fa-icon icon="plus" /> Adicionar campo
              </CButton>

              <CButton color="link" size="sm" @click="irParaAvancado">
                Opções avançadas
              </CButton>
            </div>
          </template>

          <!-- VISTA: LISTA -->
          <template v-if="vista === 'lista'">
            <div v-if="campos.length === 0" class="empty-state">
              <div class="empty-icon"><fa-icon icon="cubes" /></div>
              <div class="empty-text">Nenhum mapeamento cadastrado</div>
              <div class="empty-desc">
                {{ vocabulario.resumo }}
                <br />Exemplo: <code>{{ vocabulario.exemploDe }}</code> → <code>{{ vocabulario.exemploPara }}</code>
              </div>
              <div class="empty-exemplos">
                <div class="exemplo-card">
                  <fa-icon icon="exchange-alt" class="exemplo-ico" />
                  <strong>Campo simples</strong>
                  <span>{{ vocabulario.simplesResumo }}</span>
                </div>
                <div class="exemplo-card">
                  <fa-icon icon="code-branch" class="exemplo-ico" />
                  <strong>Condicional</strong>
                  <span>Lógica E/OU + múltiplas saídas por regra</span>
                </div>
                <div class="exemplo-card">
                  <fa-icon icon="table" class="exemplo-ico" />
                  <strong>Mapeamento</strong>
                  <span>De-para entre valores (1 → "PF", 2 → "PJ")</span>
                </div>
              </div>
              <div v-if="tiposImportaveis.length > 0" class="empty-importar">
                <span class="importar-label">Ou copie os mapeamentos de outro tipo:</span>
                <div class="importar-controle">
                  <select v-model="tipoParaImportar" class="form-control form-control-sm importar-select">
                    <option value="">Selecione um tipo…</option>
                    <option v-for="t in tiposImportaveis" :key="t.chave" :value="t.chave">
                      {{ t.titulo }} ({{ t.qtd }} mapeamentos)
                    </option>
                  </select>
                  <CButton
                    color="primary"
                    variant="outline"
                    size="sm"
                    :disabled="!tipoParaImportar"
                    @click="importarDeOutroTipo"
                  >
                    <fa-icon icon="file-import" /> Importar
                  </CButton>
                </div>
              </div>
            </div>

            <div
              v-for="(campo, idx) in campos"
              :key="idx"
              class="lista-card"
              :class="{ 'lista-card--invalid': !isCampoValido(campo) }"
              @click="editandoNomeIdx === idx ? null : abrirEditor(idx)"
            >
              <span class="lista-ordem">#{{ idx + 1 }}</span>
              <span class="lista-tipo-badge" :class="badgeClass(campo)">
                <fa-icon :icon="badgeIcone(campo)" /> {{ badgeLabel(campo) }}
              </span>
              <template v-if="editandoNomeIdx === idx">
                <div class="lista-nome-edit" @click.stop>
                  <input
                    ref="inputNome"
                    type="text"
                    class="form-control form-control-sm"
                    v-model="nomeEditando"
                    :placeholder="resumoLinha(campo)"
                    @keyup.enter="salvarNome(idx)"
                    @keyup.esc="cancelarEdicaoNome"
                  />
                  <CButton color="link" size="sm" class="btn-icon" @click="restaurarNomePadrao" title="Voltar ao nome padrão" aria-label="Restaurar nome padrão">
                    <fa-icon icon="undo" />
                  </CButton>
                  <CButton color="link" size="sm" class="btn-icon" @click="salvarNome(idx)" title="Confirmar" aria-label="Confirmar nome">
                    <fa-icon icon="check" />
                  </CButton>
                  <CButton color="link" size="sm" class="btn-icon" @click="cancelarEdicaoNome" title="Cancelar" aria-label="Cancelar edição de nome">
                    <fa-icon icon="times" />
                  </CButton>
                </div>
              </template>
              <span v-else class="lista-resumo" :class="{ 'lista-resumo--custom': !!campo.nome }">
                {{ campo.nome || resumoLinha(campo) }}
              </span>
              <div v-if="editandoNomeIdx !== idx" class="lista-acoes" @click.stop>
                <CButton color="link" size="sm" class="btn-icon" @click="iniciarEdicaoNome(idx)" title="Renomear" aria-label="Renomear mapeamento">
                  <fa-icon icon="tag" />
                </CButton>
                <CButton color="link" size="sm" class="btn-icon" @click="abrirEditor(idx)" title="Editar" aria-label="Editar mapeamento">
                  <fa-icon icon="pencil-alt" />
                </CButton>
                <CButton color="link" size="sm" class="btn-icon" @click="duplicarCampo(idx)" title="Duplicar" aria-label="Duplicar mapeamento">
                  <fa-icon icon="copy" />
                </CButton>
                <CButton color="danger" variant="ghost" size="sm" class="btn-icon" @click="onRemoveCampo(idx)" title="Remover" aria-label="Remover mapeamento">
                  <fa-icon icon="trash-alt" />
                </CButton>
              </div>
            </div>

            <CButton color="primary" variant="outline" size="sm" class="btn-add-mapeamento btn-dashed" @click="abrirSeletor">
              <fa-icon icon="plus" /> Adicionar mapeamento
            </CButton>

            <CButton v-if="embutido" color="link" size="sm" class="btn-voltar-simples" @click="irParaSimples">
              <fa-icon icon="arrow-left" /> Voltar ao modo simples
            </CButton>
          </template>

          <!-- VISTA: SELETOR DE TIPO -->
          <TipoRegraSelector
            v-else-if="vista === 'tipo'"
            :vocabulario="tipo.vocabulario || {}"
            @voltar="voltarLista"
            @selecionar="criarComTipo"
          />

          <!-- VISTA: EDITOR DE REGRA -->
          <template v-else-if="vista === 'editor' && campoEditandoRef">
            <div class="editor-header">
              <CButton color="link" size="sm" class="btn-voltar" @click="voltarLista">
                <fa-icon icon="arrow-left" /> Voltar para a lista
              </CButton>
              <div class="editor-titulo">
                {{ campoEditandoRef.regra ? badgeLabel(campoEditandoRef) : 'Campo simples' }}
              </div>
            </div>

            <div v-if="mostrarErros && errosResumo.length" class="erros-summary" role="alert">
              <div class="erros-summary-header">
                <fa-icon icon="exclamation-triangle" />
                <strong>{{ errosResumo.length }} problema(s) impedem o salvamento</strong>
              </div>
              <ul class="erros-lista">
                <li v-for="(e, i) in errosResumo" :key="i">
                  <strong>{{ e.titulo }}:</strong> {{ e.descricao }}
                </li>
              </ul>
            </div>

            <!-- Modo simples -->
            <div v-if="!campoEditandoRef.regra" class="editor-secao">
              <div class="secao-titulo">{{ vocabulario.origem }}</div>
              <div class="row form-group">
                <div class="col-md-12">
                  <label class="field-label">{{ campoDe(campoEditandoRef.de) }}</label>
                  <input
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': mostrarErros && (!campoEditandoRef.de || campoEditandoRef.de.trim().length === 0) }"
                      :aria-invalid="mostrarErros && (!campoEditandoRef.de || campoEditandoRef.de.trim().length === 0)"
                      type="text"
                      v-model="campoEditandoRef.de"
                  />
                  <div v-if="mostrarErros && (!campoEditandoRef.de || !campoEditandoRef.de.trim())" class="invalid-feedback d-block">
                    Campo de origem é obrigatório.
                  </div>
                  <CButton v-if="possuiCamposDe" color="primary" variant="ghost" size="sm" class="btn-selecionar" @click="abrirListaDe($event, campoEditandoRef)">
                    Selecionar da lista
                  </CButton>
                </div>
              </div>
            </div>

            <!-- Modo regra -->
            <div v-else class="editor-secao">
              <RegraCampoEditor
                  :value="campoEditandoRef.regra"
                  :campos="camposParaRegra"
                  :operadores="operadores"
                  :modo-troca-tipo="false"
                  :para-value="campoEditandoRef.para || ''"
                  :possui-campos-para="possuiCamposPara"
                  :placeholder-para="campoPara(campoEditandoRef.para)"
                  :mostrar-erros="mostrarErros"
                  @input="atualizarRegra(campoEditandoRef, $event)"
                  @update:paraValue="campoEditandoRef.para = $event"
                  @selecionar-para="abrirListaPara($event, campoEditandoRef)"
              />
            </div>

            <div v-if="!isCondicional(campoEditandoRef)" class="editor-secao">
              <div class="secao-titulo">{{ vocabulario.destino }}</div>
              <div class="row form-group">
                <div class="col-md-12">
                  <label class="field-label">{{ campoPara(campoEditandoRef.para) }}</label>
                  <input
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': mostrarErros && (!campoEditandoRef.para || campoEditandoRef.para.trim().length === 0) }"
                      :aria-invalid="mostrarErros && (!campoEditandoRef.para || campoEditandoRef.para.trim().length === 0)"
                      type="text"
                      v-model="campoEditandoRef.para"
                  />
                  <div v-if="mostrarErros && (!campoEditandoRef.para || !campoEditandoRef.para.trim())" class="invalid-feedback d-block">
                    Campo de destino é obrigatório.
                  </div>
                  <CButton v-if="possuiCamposPara" color="primary" variant="ghost" size="sm" class="btn-selecionar" @click="abrirListaPara($event, campoEditandoRef)">
                    Selecionar da lista
                  </CButton>
                </div>
              </div>
            </div>

            <div class="editor-secao">
              <CButton color="link" size="sm" class="secao-toggle" @click="opcoesAbertas = !opcoesAbertas">
                <fa-icon :icon="opcoesAbertas ? 'chevron-down' : 'chevron-right'" />
                Opções avançadas (funções, formato, valor padrão, incluir se nulo)
              </CButton>
              <div v-if="opcoesAbertas">
                <div class="row form-group opcoes-row">
                  <div class="col-md-3">
                    <label class="field-label">
                      Valor padrão
                      <fa-icon
                        icon="info-circle"
                        class="info-icon"
                        title="Aplicado quando a regra retorna null, 0, false ou string vazia. Se você precisa enviar 0 ou false literais ao ERP, defina este campo como '0' ou 'false'."
                      />
                    </label>
                    <input class="form-control form-control-sm" type="text" v-model="campoEditandoRef.valor_padrao" />
                    <small class="text-muted field-hint">
                      Usado quando a regra retorna vazio. Para enviar <code>0</code>/<code>false</code> literal, preencha aqui.
                    </small>
                  </div>
                  <div class="col-md-3">
                    <label class="field-label">Formato</label>
                    <select v-model="campoEditandoRef.conversao" class="form-control form-control-sm">
                      <option v-for="(value, label) in formatos" :key="label" :value="value">{{ label }}</option>
                    </select>
                  </div>
                  <div v-if="validaFormato(campoEditandoRef)" class="col-md-3">
                    <label class="field-label">Inverter sinal</label>
                    <select v-model="campoEditandoRef.inverte_sinal" class="form-control form-control-sm">
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label class="field-label">Incluir se nulo</label>
                    <select v-model="campoEditandoRef.incluir_se_nulo" class="form-control form-control-sm">
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                  </div>
                </div>
                <div v-if="!isCondicional(campoEditandoRef)" class="row form-group">
                  <div class="col-md-12">
                    <label class="field-label">Funções de formatação (aplicadas em ordem, antes do formato)</label>
                    <FuncoesPipeline v-model="campoEditandoRef.funcoes" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="modal-footer-bar">
        <CButton v-if="!embutido" variant="outline" color="secondary" @click="close">Cancelar</CButton>
        <!--
          Só na lista: é ali que "descartar" quer dizer voltar ao que está
          gravado. No meio da edição de um campo, quem volta é o "Voltar para a
          lista", e um botão de descarte ao lado dele pareceria desfazer só o
          campo aberto.
        -->
        <CButton
          v-else-if="vistaEhLista && alteracoesPendentes"
          variant="outline"
          color="secondary"
          @click="descartarAlteracoes"
        >
          Descartar alterações
        </CButton>
        <span v-if="vistaEhLista && alteracoesPendentes" class="alteracoes-pendentes">
          <fa-icon icon="circle" /> Alterações não salvas
        </span>
        <div class="footer-spacer"></div>
        <CButton
          v-if="vista === 'editor'"
          color="primary"
          @click="trySalvarEditor"
          title="Confirma este mapeamento e volta para a lista (ainda não persiste no servidor)"
        >
          <fa-icon icon="check" /> Aplicar mapeamento
        </CButton>
        <CButton
          v-else-if="vistaEhLista"
          color="success"
          :disabled="!camposValidos || !alteracoesPendentes"
          @click="handleSubmit"
          title="Persiste todos os mapeamentos no servidor"
        >
          <fa-icon icon="save" /> Salvar tudo
        </CButton>
      </div>
    </component>
  </div>
</template>

<script>
import CloseModal from "../../../components/CloseModal";
import CamposDisponiveis from "./CamposDisponiveis";
import { condicoesSemTipoValor } from "./regra/tipoValorCondicao";
import RegraCampoEditor, { novaRegra } from "./RegraCampoEditor";
import TipoRegraSelector from "./TipoRegraSelector";
import FuncoesPipeline from "./FuncoesPipeline";
import { isEmpty, cloneDeep } from "lodash";

const campoMapeado = (tipo) => ({
  'de': '',
  'para': '',
  'conversao': null,
  'funcoes': [],
  'inverte_sinal': 0,
  'incluir_se_nulo': 1,
  'valor_padrao': '',
  'ordem': 1,
  'regra': null,
  tipo
});

const TIPO_BADGES = {
  simples:      { label: 'Simples',      icone: 'exchange-alt', cls: 'badge--simples' },
  condicional:  { label: 'Condicional',  icone: 'code-branch',  cls: 'badge--condicional' },
  mapeamento:   { label: 'Mapeamento',   icone: 'table',        cls: 'badge--mapeamento' },
  concatenacao: { label: 'Concatenação', icone: 'link',         cls: 'badge--concatenacao' },
  coalesce:     { label: '1º disponível',icone: 'list-ol',      cls: 'badge--coalesce' },
};

/*
 * Editor de DE/PARA de um tipo de mapeamento.
 *
 * Tem DOIS consumidores, e é por isso que tudo entra por propriedade em vez de
 * ser buscado aqui dentro: a tela Campos de Integração, que o abre para
 * qualquer tipo do sistema, e a tela de uma integração, que o abre para o tipo
 * daquele conector — sob a permissão de Integrações, que é concessão separada
 * da de Campos de Integração. Ao mexer aqui, os dois caminhos precisam ser
 * conferidos.
 *
 * `todosCampos` e `grupos` são opcionais: sem eles, some a opção de importar
 * mapeamentos de outro tipo, que é justamente o que não se quer oferecer a quem
 * entrou pela integração.
 */
export default {
  name: "Edit",
  components: {
    CamposDisponiveis,
    CloseModal,
    RegraCampoEditor,
    TipoRegraSelector,
    FuncoesPipeline,
  },
  props: [
    /*
     * Renderiza sem o modal, como seção da página que o hospeda.
     *
     * Estas props são declaradas em array, que não converte atributo vazio em
     * `true` — por isso o consumidor precisa passar `:embutido="true"`, e não
     * só `embutido`.
     */
    'embutido',
    'close',
    'tipo',
    'campos',
    'formatos',
    'funcoesCatalogo',
    'operadores',
    'onSubmit',
    'todosCampos',
    'grupos',
  ],
  provide() {
    const self = this;
    // Getter reativo: o catálogo é carregado de forma assíncrona, então
    // expomos um acessor que lê a prop reativa no momento do uso (padrão
    // de provide/inject reativo do Vue 2), consumido por FuncoesPipeline.
    return {
      catalogoFuncoes: {
        get value() {
          return self.funcoesCatalogo || [];
        },
      },
    };
  },
  mounted() {
    // `before-open` é evento do modal; embutido, ele nunca dispara e o snapshot
    // ficaria vazio — toda a lista apareceria como "alteração não salva".
    if (this.embutido) {
      this.onBeforeOpen();
    }
  },
  data() {
    return {
      // Embutido na tela de uma integração, o assunto é vincular campo a
      // campo; a lista de cartões, com regras e funções, é a vista avançada.
      vista: this.embutido ? 'simples' : 'lista',
      vistaDeLista: this.embutido ? 'simples' : 'lista',
      indexEditando: null,
      campoEmEdicao: {},
      indiceCampoEmEdicao: null,
      // Qual das duas pontas está escolhendo campo, e de onde a lista pende.
      listaAberta: null,
      ancoraDaLista: null,
      opcoesAbertas: false,
      editandoNomeIdx: null,
      nomeEditando: '',
      mostrarErros: false,
      snapshotCampos: '[]',
      tipoParaImportar: '',
    };
  },
  watch: {
    'tipo.chave'() {
      // Sempre que mudar o tipo selecionado na tela principal, voltar para lista
      this.vista = this.vistaDeLista;
      this.indexEditando = null;
      this.opcoesAbertas = false;
    },
  },
  computed: {
    // A vista simples e a avançada são as duas formas da mesma lista: o que
    // vale para uma (salvar, descartar, avisar de pendência) vale para a outra.
    vistaEhLista() {
      return this.vista === 'simples' || this.vista === 'lista';
    },

    opcoesDe() {
      return this.opcoesDoDicionario(this.tipo.de);
    },

    opcoesPara() {
      return this.opcoesDoDicionario(this.tipo.para);
    },

    /**
     * Como este tipo de mapeamento chama as duas pontas.
     *
     * O padrão descreve o sentido da maioria — dado nosso indo para o ERP. Um
     * tipo que anda no sentido contrário, como o lead que chega do RD Station,
     * declara o seu na configuração e sobrescreve só o que precisar.
     */
    vocabulario() {
      const declarado = (this.tipo && this.tipo.vocabulario) || {};
      const exemplos = declarado.exemplos || {};
      const [exemploDe, exemploPara] = String(exemplos.simples || 'pedido.id → U_VS_PedidoEcommerce')
        .split('→')
        .map((parte) => parte.trim());

      return {
        origem: declarado.origem || 'Origem',
        destino: declarado.destino || 'Destino no ERP',
        resumo: declarado.resumo || 'Mapeamentos transformam dados da Verso em campos do ERP.',
        simplesResumo: declarado.descricao_simples
          || 'Envia o valor da Verso direto para um campo do ERP',
        exemploDe,
        exemploPara,
      };
    },

    /*
     * O modal recebe as mesmas propriedades de antes; ficam aqui porque o
     * wrapper passou a ser dinâmico e um `v-bind` condicional é o que permite
     * não despejá-las numa `div`.
     */
    propriedadesDoModal() {
      return {
        name: 'editCampo',
        height: 'auto',
        width: '90%',
        maxWidth: 1200,
        adaptive: true,
        scrollable: true,
        clickToClose: false,
      };
    },
    campoEditandoRef() {
      if (this.indexEditando === null) return null;
      return this.campos[this.indexEditando];
    },
    camposValidos() {
      return this.campos.every((c) => this.isCampoValido(c));
    },
    alteracoesPendentes() {
      return JSON.stringify(this.campos || []) !== this.snapshotCampos;
    },
    tiposImportaveis() {
      if (!this.todosCampos || !this.grupos) return [];
      const result = [];
      for (const grupo of Object.values(this.grupos)) {
        for (const [chave, t] of Object.entries(grupo.tipos || {})) {
          if (chave === this.tipo.chave) continue;
          const arr = this.todosCampos[chave] || [];
          if (arr.length > 0) result.push({ chave, titulo: t.titulo, qtd: arr.length });
        }
      }
      return result.sort((a, b) => a.titulo.localeCompare(b.titulo));
    },
    errosResumo() {
      const campo = this.campoEditandoRef;
      if (!campo) return [];
      const erros = [];
      if (campo.regra) {
        if (campo.regra.tipo === 'condicional') {
          const casos = campo.regra.casos || [];
          if (casos.length === 0) {
            erros.push({ titulo: 'Sem regras', descricao: 'Adicione ao menos uma regra condicional.' });
          }
          casos.forEach((caso, ci) => {
            const saidas = Array.isArray(caso.entao) ? caso.entao : [];
            if (saidas.length > 0) {
              saidas.forEach((s, si) => {
                const para = s && s.para ? String(s.para).trim() : '';
                if (!para) erros.push({ titulo: `Regra ${ci + 1} → destino ${si + 1}`, descricao: 'Campo "Para" vazio.' });
                const e = s && s.expressao;
                const v = e && e.valor != null ? String(e.valor).trim() : '';
                const c = e && e.caminho != null ? String(e.caminho).trim() : '';
                if (!v && !c) erros.push({ titulo: `Regra ${ci + 1} → destino ${si + 1}`, descricao: 'Expressão "De" sem valor.' });
              });
            } else {
              const entao = caso.entao;
              const v = entao && entao.valor != null ? String(entao.valor).trim() : '';
              const c = entao && entao.caminho != null ? String(entao.caminho).trim() : '';
              if (v || c) {
                if (!campo.para || !campo.para.trim()) {
                  erros.push({ titulo: `Regra ${ci + 1}`, descricao: 'Campo "Para" vazio.' });
                }
              }
            }
          });
          condicoesSemTipoValor(campo.regra).forEach((p) => {
            erros.push({
              titulo: `Regra ${p.regra} → condição ${p.condicao}`,
              descricao: 'Escolha o tipo do valor (Valor fixo ou Outro campo).',
            });
          });
          const senao = campo.regra.senao;
          if (Array.isArray(senao) && senao.length > 0) {
            senao.forEach((s, si) => {
              const para = s && s.para ? String(s.para).trim() : '';
              if (!para) erros.push({ titulo: `Senão → destino ${si + 1}`, descricao: 'Campo "Para" vazio.' });
              const e = s && s.expressao;
              const v = e && e.valor != null ? String(e.valor).trim() : '';
              const c = e && e.caminho != null ? String(e.caminho).trim() : '';
              if (!v && !c) erros.push({ titulo: `Senão → destino ${si + 1}`, descricao: 'Expressão "De" sem valor.' });
            });
          }
        } else if (!campo.para || !campo.para.trim()) {
          erros.push({ titulo: 'Destino', descricao: 'Campo "Para" vazio.' });
        }
      } else {
        if (!campo.de || !campo.de.trim()) erros.push({ titulo: 'Origem', descricao: 'Campo "De" vazio.' });
        if (!campo.para || !campo.para.trim()) erros.push({ titulo: 'Destino', descricao: 'Campo "Para" vazio.' });
      }
      return erros;
    },
    possuiCamposDe() {
      return !isEmpty(this.tipo.de);
    },
    possuiCamposPara() {
      return !isEmpty(this.tipo.para);
    },
    camposParaRegra() {
      if (isEmpty(this.tipo.de)) return [];
      return Object.entries(this.tipo.de).map(([value, label]) => ({ value, label }));
    },
  },
  methods: {
    isCampoValido(campo) {
      if (!campo) return false;
      if (campo.regra) {
        if (campo.regra.tipo === 'condicional') {
          return this.isCondicionalValido(campo);
        }
        return campo.para && campo.para.trim().length > 0;
      }
      return campo.de && campo.de.trim().length > 0
          && campo.para && campo.para.trim().length > 0;
    },
    isCondicional(campo) {
      return campo && campo.regra && campo.regra.tipo === 'condicional';
    },
    isCondicionalValido(campo) {
      const hasRowPara = !!(campo.para && String(campo.para).trim().length);
      const expressaoTemValor = (e) => {
        if (!e || typeof e !== 'object') return false;
        const v = e.valor != null ? String(e.valor).trim() : '';
        const c = e.caminho != null ? String(e.caminho).trim() : '';
        return v.length > 0 || c.length > 0;
      };
      const isSaidaValida = (saida) => {
        if (Array.isArray(saida)) {
          return saida.length > 0 && saida.every((it) => {
            const para = it && it.para ? String(it.para).trim() : '';
            return para.length > 0 && expressaoTemValor(it && it.expressao);
          });
        }
        if (!expressaoTemValor(saida)) return true;
        return hasRowPara;
      };
      const casos = (campo.regra.casos || []);
      if (casos.length === 0) return false;
      const todosCasosValidos = casos.every((c) => isSaidaValida(c.entao));
      const senao = campo.regra.senao;
      const senaoValido = senao == null ? true : isSaidaValida(senao);
      const condicoesComTipo = condicoesSemTipoValor(campo.regra).length === 0;
      return todosCasosValidos && senaoValido && condicoesComTipo;
    },
    isRegraEmpty(regra) {
      if (!regra) return true;
      if (regra.tipo !== 'condicional') return false;
      const expressaoTemValor = (e) => {
        if (!e || typeof e !== 'object') return false;
        return (e.valor != null && String(e.valor).trim().length > 0)
          || (e.caminho != null && String(e.caminho).trim().length > 0);
      };
      const saidaTemConteudo = (saida) => {
        if (Array.isArray(saida)) {
          return saida.some((it) => (it && it.para && String(it.para).trim()) || expressaoTemValor(it && it.expressao));
        }
        return expressaoTemValor(saida);
      };
      const algumCampo = (regra.casos || []).some((c) =>
        ((c && c.condicao && c.condicao.grupos) || []).some((g) =>
          ((g && g.condicoes) || []).some((cd) => cd && cd.campo)
        )
      );
      const algumEntao = (regra.casos || []).some((c) => saidaTemConteudo(c.entao));
      const senaoCheio = saidaTemConteudo(regra.senao);
      return !(algumCampo || algumEntao || senaoCheio);
    },
    trySalvarEditor() {
      if (!this.isCampoValido(this.campoEditandoRef || {})) {
        this.mostrarErros = true;
        return;
      }
      this.mostrarErros = false;
      this.voltarLista();
    },
    /*
     * Sem modal não há "fechar sem salvar": o equivalente é voltar a lista ao
     * que está gravado, e quem sabe disso é o pai, que a carregou.
     */
    descartarAlteracoes() {
      this.$emit('descartar');
    },

    onBeforeOpen() {
      // Garante estado limpo a cada abertura — sem isso, reabrir o modal
      // mantém `vista`/`indexEditando` da sessão anterior e a tela fica
      // travada em uma vista inválida.
      this.vista = this.vistaDeLista;
      this.indexEditando = null;
      this.indiceCampoEmEdicao = null;
      this.listaAberta = null;
      this.opcoesAbertas = false;
      this.editandoNomeIdx = null;
      this.nomeEditando = '';
      this.mostrarErros = false;
      // $nextTick garante snapshot APÓS o pai propagar a prop `campos`
      // do tipo escolhido — evita falso positivo de "alterações não salvas".
      this.$nextTick(() => {
        this.snapshotCampos = JSON.stringify(this.campos || []);
      });
    },
    temAlteracoesPendentes() {
      return JSON.stringify(this.campos || []) !== this.snapshotCampos;
    },
    tentarFechar() {
      if (!this.temAlteracoesPendentes()) {
        this.close();
        return;
      }
      this.$swal({
        title: 'Descartar alterações?',
        text: 'Você possui mapeamentos não salvos. Se sair agora, eles serão perdidos.',
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Descartar',
        cancelButtonText: 'Continuar editando',
      })
        .then((res) => {
          if (res.value) this.close();
        })
        .catch(() => {});
    },
    iniciarEdicaoNome(idx) {
      this.editandoNomeIdx = idx;
      this.nomeEditando = this.campos[idx].nome || '';
      this.$nextTick(() => {
        const input = this.$refs.inputNome;
        const el = Array.isArray(input) ? input[0] : input;
        if (el) el.focus();
      });
    },
    cancelarEdicaoNome() {
      this.editandoNomeIdx = null;
      this.nomeEditando = '';
    },
    restaurarNomePadrao() {
      this.nomeEditando = '';
    },
    salvarNome(idx) {
      const campo = this.campos[idx];
      const valor = (this.nomeEditando || '').trim();
      if (valor) {
        this.$set(campo, 'nome', valor);
      } else {
        this.$delete(campo, 'nome');
      }
      this.cancelarEdicaoNome();
    },
    validaFormato(campo) {
      return campo.conversao == 'int' || campo.conversao == 'float';
    },
    alterarCampoDe(novoValor) {
      const alvo = this.campos[this.indiceCampoEmEdicao];
      if (alvo) this.$set(alvo, 'de', novoValor);
    },
    alterarCampoPara(novoValor) {
      const alvo = this.campos[this.indiceCampoEmEdicao];
      if (alvo) this.$set(alvo, 'para', novoValor);
    },
    abrirListaDe(evento, campo) {
      // Guarda o índice no array em vez da referência — evita que mutações
      // tardias da lista vazem para o campo errado se o usuário navegar.
      this.indiceCampoEmEdicao = this.campos.indexOf(campo);
      this.ancoraDaLista = this.retanguloDoClique(evento);
      this.listaAberta = 'de';
    },
    abrirListaPara(evento, campo) {
      this.indiceCampoEmEdicao = this.campos.indexOf(campo);
      this.ancoraDaLista = this.retanguloDoClique(evento);
      this.listaAberta = 'para';
    },
    fecharLista() {
      this.listaAberta = null;
    },
    /*
     * De onde a lista se pendura. Vem do botão clicado, inclusive quando o
     * clique nasce dentro do editor de regra e sobe por evento — por isso o
     * retângulo viaja junto, em vez de ser procurado por referência aqui.
     */
    retanguloDoClique(evento) {
      const alvo = evento && (evento.currentTarget || evento.target);

      if (!alvo || typeof alvo.getBoundingClientRect !== 'function') {
        return null;
      }

      const retangulo = alvo.getBoundingClientRect();

      return {
        top: retangulo.top,
        bottom: retangulo.bottom,
        left: retangulo.left,
        width: retangulo.width,
      };
    },
    /*
     * O nome amigável do campo escolhido, quando ele está no dicionário — é o
     * que confirma que o caminho digitado existe mesmo. Sem o prefixo "De:" /
     * "Para:": o título da seção logo acima já diz qual das duas pontas é esta,
     * e repetir empurrava a informação útil para o fim da linha.
     */
    campoDe(nomeCampo) {
      return this.rotuloDoCampo(this.tipo.de, nomeCampo);
    },
    campoPara(nomeCampo) {
      return this.rotuloDoCampo(this.tipo.para, nomeCampo);
    },

    /*
     * Campo ainda em branco não tem rótulo: dizer "fora da lista" antes de o
     * usuário digitar qualquer coisa soa como erro do que ele ainda nem fez.
     */
    rotuloDoCampo(dicionario, nomeCampo) {
      if (!nomeCampo || !String(nomeCampo).trim()) {
        return '';
      }

      return (dicionario && dicionario[nomeCampo]) || 'Campo fora da lista';
    },
    badgeClass(campo) {
      const t = campo.regra ? campo.regra.tipo : 'simples';
      return (TIPO_BADGES[t] || TIPO_BADGES.simples).cls;
    },
    badgeIcone(campo) {
      const t = campo.regra ? campo.regra.tipo : 'simples';
      return (TIPO_BADGES[t] || TIPO_BADGES.simples).icone;
    },
    badgeLabel(campo) {
      const t = campo.regra ? campo.regra.tipo : 'simples';
      return (TIPO_BADGES[t] || TIPO_BADGES.simples).label;
    },
    resumoLinha(campo) {
      const para = campo.para || '?';
      if (!campo.regra) {
        const de = campo.de || '?';
        return `${de}  →  ${para}`;
      }
      switch (campo.regra.tipo) {
        case 'mapeamento': {
          const origem = campo.regra.campo || '?';
          const n = Object.keys(campo.regra.mapa || {}).length;
          return `${origem} (${n} tradução${n === 1 ? '' : 'ões'})  →  ${para}`;
        }
        case 'concatenacao': {
          const n = (campo.regra.partes || []).length;
          return `${n} parte${n === 1 ? '' : 's'} concatenada${n === 1 ? '' : 's'}  →  ${para}`;
        }
        case 'coalesce': {
          const n = (campo.regra.campos || []).length;
          return `${n} campo${n === 1 ? '' : 's'} (1º preenchido)  →  ${para}`;
        }
        case 'condicional': {
          const n = (campo.regra.casos || []).length;
          return `${n} regra${n === 1 ? '' : 's'} + fallback  →  ${para}`;
        }
        default:
          return `(regra)  →  ${para}`;
      }
    },
    abrirSeletor() {
      this.vista = 'tipo';
    },

    /**
     * O dicionário vira lista de opções para o select com busca.
     *
     * O identificador entra junto do nome porque é ele que aparece no payload
     * do serviço: quem está conferindo um vínculo contra a documentação do RD
     * procura por `cf_documento`, não por "Documento".
     */
    opcoesDoDicionario(dicionario) {
      return Object.entries(dicionario || {}).map(([valor, rotulo]) => ({
        valor,
        rotulo: rotulo || valor,
      }));
    },

    /*
     * A escolha é pelo nome, mas quem confere um vínculo contra a documentação
     * do serviço procura pelo identificador — então os dois buscam.
     */
    filtrarOpcao(opcao, rotulo, termo) {
      const procurado = String(termo || '').toLowerCase();

      return `${rotulo || ''} ${opcao.valor || ''}`.toLowerCase().indexOf(procurado) > -1;
    },

    /*
     * O que o select mostra como escolhido. Campo gravado fora do dicionário
     * — digitado à mão no editor avançado, ou de uma conta que mudou — continua
     * aparecendo pelo identificador: sumir seria pior do que destoar.
     */
    opcaoDoCampo(dicionario, valor) {
      if (!valor) {
        return null;
      }

      return { valor, rotulo: (dicionario || {})[valor] || valor };
    },

    definirDe(indice, opcao) {
      const campo = this.campos[indice];

      if (campo) {
        this.$set(campo, 'de', opcao ? opcao.valor : '');
      }
    },

    definirPara(indice, opcao) {
      const campo = this.campos[indice];

      if (campo) {
        this.$set(campo, 'para', opcao ? opcao.valor : '');
      }
    },

    // Na vista simples, adicionar é acrescentar uma linha vazia — sem perguntar
    // antes de que tipo ela é, porque a resposta é sempre "campo a campo".
    adicionarVinculo() {
      this.campos.push(campoMapeado(this.tipo.chave));
    },

    irParaAvancado() {
      this.vistaDeLista = 'lista';
      this.vista = 'lista';
    },

    irParaSimples() {
      this.vistaDeLista = 'simples';
      this.vista = 'simples';
    },
    importarDeOutroTipo() {
      if (!this.tipoParaImportar) return;
      const fonte = (this.todosCampos && this.todosCampos[this.tipoParaImportar]) || [];
      if (fonte.length === 0) return;
      this.$swal({
        title: `Importar ${fonte.length} mapeamento(s)?`,
        text: 'Os mapeamentos serão copiados como ponto de partida — você ainda precisa salvar para persistir.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Importar',
        cancelButtonText: 'Cancelar',
      }).then((res) => {
        if (!res.value) return;
        const copia = cloneDeep(fonte);
        this.campos.splice(0, this.campos.length, ...copia);
        this.tipoParaImportar = '';
      });
    },
    criarComTipo(tipoEscolhido) {
      try {
        const novo = campoMapeado(this.tipo.chave);
        if (tipoEscolhido !== 'simples') {
          novo.regra = novaRegra(tipoEscolhido);
        }
        this.campos.push(novo);
        this.indexEditando = this.campos.length - 1;
        this.vista = 'editor';
        this.opcoesAbertas = false;
        this.mostrarErros = false;
      } catch (e) {
        // Mantém o usuário na vista 'tipo' com feedback explícito em vez de
        // entrar em 'editor' com campoEditandoRef indefinido (template quebra).
        this.$swal({
          title: 'Não foi possível criar este mapeamento',
          text: e && e.message ? e.message : 'Erro desconhecido.',
          icon: 'error',
        });
        this.vista = 'tipo';
      }
    },
    abrirEditor(idx) {
      const campo = this.campos[idx];
      // Registros antigos não possuem `funcoes`; garante a chave reativa
      // para que o v-model do pipeline funcione no Vue 2.
      if (campo && !Array.isArray(campo.funcoes)) {
        this.$set(campo, 'funcoes', []);
      }
      this.indexEditando = idx;
      this.vista = 'editor';
      this.opcoesAbertas = false;
      this.mostrarErros = false;
    },
    voltarLista() {
      // Se voltou de um editor sem nada preenchido, descarta o registro
      // recém-criado (inclusive quando o usuário escolheu um tipo de regra
      // mas não chegou a configurá-la).
      if (this.vista === 'editor' && this.indexEditando !== null) {
        const campo = this.campos[this.indexEditando];
        if (campo && !campo.de && !campo.para && this.isRegraEmpty(campo.regra)) {
          this.campos.splice(this.indexEditando, 1);
        }
      }
      this.indexEditando = null;
      this.vista = this.vistaDeLista;
      this.mostrarErros = false;
    },
    atualizarRegra(campo, regra) {
      this.$set(campo, 'regra', regra);
      this.$set(campo, 'de', '');
    },
    duplicarCampo(index) {
      const original = this.campos[index];
      if (!original) return;
      const copia = cloneDeep(original);
      if (copia.nome) {
        copia.nome = `${copia.nome} (cópia)`;
      }
      this.campos.splice(index + 1, 0, copia);
    },
    onRemoveCampo(index) {
      this.$swal({
        title: 'Confirma remover este mapeamento?',
        text: 'Essa ação não poderá ser desfeita.',
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Remover',
        cancelButtonText: 'Cancelar',
      })
        .then((res) => {
          if (res.value) {
            this.campos.splice(index, 1);
            if (this.editandoNomeIdx === index) {
              this.cancelarEdicaoNome();
            }
          }
        })
        .catch(() => {});
    },
    handleSubmit() {
      this.onSubmit(this.campos, this.tipo.chave);
    },
  },
};
</script>

<style scoped>
.modal-header-info {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-default);
}
.header-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--primary);
}
.header-desc {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 4px;
}
.header-desc code {
  font-size: 11px;
  color: var(--text-strong);
  background: var(--border-soft);
  padding: 1px 5px;
  border-radius: 3px;
}

/* Empty state */
.empty-state { text-align: center; padding: 40px 20px; }
.empty-icon {
  width: 56px; height: 56px; border-radius: 14px;
  background: var(--primary-hover-bg); color: var(--primary);
  font-size: 22px;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 12px;
}
.empty-text { font-weight: 600; font-size: 15px; color: var(--text-darkest); }
.empty-desc {
  font-size: 13px;
  color: var(--text-muted);
  margin-top: 4px;
  line-height: 1.5;
}
.empty-desc code {
  background: var(--bg-subtle);
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: var(--text-strong);
}
.empty-exemplos {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  max-width: 600px;
  margin: 18px auto 0;
}
.exemplo-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 10px;
  border: 1px solid var(--border-default);
  border-radius: 8px;
  background: var(--bg-subtle);
  text-align: left;
  font-size: 11px;
  color: var(--text-muted);
}
.exemplo-card strong { color: var(--text-darkest); font-size: 12px; }
.exemplo-ico { color: var(--primary); margin-bottom: 4px; }
.empty-importar {
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px dashed var(--border-default);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
.importar-label {
  display: block;
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 8px;
}
.importar-controle {
  display: flex;
  gap: 8px;
  align-items: center;
}
.importar-select { flex: 1; }
@media (max-width: 767.98px) {
  .empty-exemplos { grid-template-columns: 1fr; }
  .importar-controle { flex-direction: column; align-items: stretch; }
}

/* Lista de cards */
.lista-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  margin-bottom: 6px;
  border: 1px solid var(--border-medium);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s;
}
.lista-card:hover {
  border-color: var(--primary);
  background: #fafbff;
}
.lista-card--invalid {
  border-color: #fda29b;
  background: var(--danger-bg);
}
.lista-ordem {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  background: var(--border-soft);
  padding: 2px 7px;
  border-radius: 4px;
  flex-shrink: 0;
}
.lista-tipo-badge {
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 12px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.badge--simples      { background: #eef2ff; color: #4338ca; }
.badge--condicional  { background: #fef3c7; color: #b45309; }
.badge--mapeamento   { background: #dcfce7; color: #15803d; }
.badge--concatenacao { background: #e0f2fe; color: #0369a1; }
.badge--coalesce     { background: #fce7f3; color: #be185d; }
.lista-resumo {
  flex: 1;
  font-size: 13px;
  color: var(--text-strong);
  font-family: 'Menlo', 'Consolas', monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lista-resumo--custom {
  font-family: inherit;
  color: #1f2937;
  font-weight: 500;
}
.lista-nome-edit {
  flex: 1;
  display: flex;
  gap: 4px;
  align-items: center;
}
.lista-nome-edit .form-control {
  flex: 1;
  min-width: 0;
}
.lista-acoes {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}
.btn-icon {
  padding: 0.125rem 0.4rem;
  line-height: 1;
}
.btn-dashed {
  border-style: dashed;
}
.btn-add-mapeamento {
  width: 100%;
  font-size: 13px;
  font-weight: 500;
  padding: 12px;
  margin-top: 8px;
}

/* Editor */
.editor-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border-default);
}
.btn-voltar {
  font-size: 13px;
}
.editor-titulo {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-darkest);
}
.editor-secao {
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border-soft);
}
.editor-secao:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.secao-titulo {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 8px;
}
.secao-toggle {
  font-size: 12px;
  font-weight: 500;
  padding-left: 0;
  padding-right: 0;
}
.secao-toggle ::v-deep .fa-icon,
.secao-toggle ::v-deep svg { margin-right: 6px; }
.opcoes-row { margin-top: 10px; }

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}
.btn-selecionar {
  font-size: 11px;
  margin-top: 4px;
}

/* Modal footer */
.modal-footer-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid var(--border-default);
  position: sticky;
  bottom: 0;
  background: #fff;
  z-index: 5;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.04);
}
.footer-spacer { flex: 1; }
.breadcrumb-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 12px;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border-default);
  background: var(--bg-subtle);
}
.breadcrumb-item { display: inline-flex; align-items: center; gap: 6px; }
.breadcrumb-item a {
  color: var(--primary);
  text-decoration: none;
}
.breadcrumb-item a:hover { text-decoration: underline; }
.breadcrumb-item--ativo { color: var(--text-darkest); font-weight: 500; }
.breadcrumb-sep { color: var(--text-subtle); font-size: 9px; }

.info-icon {
  color: var(--text-subtle);
  font-size: 10px;
  margin-left: 4px;
  cursor: help;
}
.info-icon:hover { color: var(--primary); }
.field-hint {
  display: block;
  font-size: 10px;
  color: var(--text-muted);
  margin-top: 3px;
  line-height: 1.4;
}
.field-hint code {
  background: var(--bg-subtle);
  padding: 0 4px;
  border-radius: 3px;
  font-size: 10px;
  color: var(--text-strong);
}

.alteracoes-pendentes {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #b45309;
  font-weight: 500;
}
.alteracoes-pendentes ::v-deep svg { font-size: 8px; }

.erros-summary {
  background: var(--danger-bg);
  border: 1px solid #fda29b;
  border-left: 4px solid var(--danger);
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 16px;
}
.erros-summary-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--danger);
  margin-bottom: 6px;
  font-size: 13px;
}
.erros-lista {
  margin: 0;
  padding-left: 22px;
  font-size: 12px;
  color: var(--text-strong);
}
.erros-lista li { line-height: 1.5; }

/* ---- Vista simples: duas colunas e uma seta ---- */
.simples-tabela {
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  overflow: visible;
}

.simples-cabecalho,
.simples-linha {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 16px 1fr 72px;
  padding: 10px 12px;
}

.simples-cabecalho {
  background: #f8f9fa;
  border-bottom: 1px solid var(--border-soft);
  border-radius: 8px 8px 0 0;
  color: var(--text-muted);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.simples-linha + .simples-linha {
  border-top: 1px solid var(--border-soft);
}

.simples-linha--invalida {
  background: #fff8f8;
}

.simples-campo {
  min-width: 0;
}

.simples-seta {
  color: var(--text-subtle);
  font-size: 11px;
}

/* A regra ocupa as três primeiras colunas: não é um par de campos. */
.simples-regra {
  align-items: center;
  display: flex;
  gap: 8px;
  grid-column: 1 / 4;
  min-width: 0;
}

.simples-regra-resumo {
  color: var(--text-strong);
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.simples-acoes {
  display: flex;
  gap: 2px;
  justify-content: flex-end;
}

.simples-rodape {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
}

.simples-vazio {
  color: var(--text-muted);
  padding: 28px 16px;
  text-align: center;
}

.simples-vazio-icone {
  color: var(--border-medium);
  font-size: 22px;
  margin-bottom: 8px;
}

.simples-vazio-texto {
  color: var(--text-strong);
  font-size: 14px;
  font-weight: 600;
}

.simples-vazio-desc {
  font-size: 12px;
  margin-top: 4px;
}

.btn-voltar-simples {
  margin-left: 8px;
}

.opcao-campo {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.opcao-id {
  background: none;
  color: var(--text-subtle);
  font-size: 10px;
  padding: 0;
}

/* Sobre o azul da opção em foco, o cinza do identificador desaparecia. */
.simples-linha >>> .v-select .dropdown-menu > .highlight .opcao-id {
  color: rgba(255, 255, 255, 0.85);
}

/* O select com busca fica da altura dos demais controles das telas de integração. */
.simples-linha >>> .v-select .dropdown-toggle {
  align-items: center;
  display: flex;
  font-size: 0.7rem;
  height: 40px;
  padding: 0 10px;
}

.simples-linha >>> .v-select .selected-tag,
.simples-linha >>> .v-select input[type='search'] {
  font-size: 0.7rem;
  line-height: 1.4;
  margin: 0;
  padding: 0;
}

.simples-linha >>> .v-select .dropdown-menu {
  font-size: 0.7rem;
}
</style>
